import { configuration } from '../../../infrastructure/clientConfigurationProvider';
import { buildStringFromParams } from '../../../infrastructure/httpCallUtilities';

export function getLookupPreviewUrlForImageWidth(
  imagesTenant: string,
  locale: string,
  productKey: string,
  productVersion: number,
  optionSelections: string,
  instructionsUri: string,
  purpose: string,
  width: number
): string {
  const lookupPreviewParams = {
    productVersion: productVersion,
    previewInstructionsUri: instructionsUri,
    purpose,
    optionSelections,
    width,
    requester: configuration.requestor,
  };

  const paramsQueryString = buildStringFromParams(lookupPreviewParams);

  const url = `${configuration.serviceUrls.lookupPreview}api/v1/${imagesTenant}/${locale}/product/${productKey}/defaultViewImage?${paramsQueryString}`;
  return url;
}
